import { ArticleList } from '../article/components/ArticleList/ArticleList';
import { ArticleHighlightedCard } from '../article/components/ArticleHighlightedCard/ArticleHighlightedCard';
import { RichTextPreview } from '../article/components/RichTextEditor/RichTextPreview';
import LeagueTable from '../league/components/LeagueTable/LeagueTable';
import { FixtureList } from '../fixtures/components/FixtureList/FixtureList';
import SponsorCard from '../league/components/SponsorCard/SponsorCard';
import { SocialNetworks } from '../league/components/SocialNetworks/SocialNetworks';
import { Ad } from '../ads/components/Ad/Ad';
import { FeaturedTags } from '../article/components/FeaturedTags/FeaturedTags';
import ContactsList from '../league/components/ContactsList/ContactsList';
import Link from '../common/components/Link/Link';
import { CmsComponent } from './contracts';
import { ClubList } from '../league/components/ClubList';
import { SponsorsGrid } from '../league/components/SponsorsGrid/SponsorsGrid';
import { NewsletterSubscribe } from '../article/components/NewsletterSubscribe';
import { TeamList } from '../league/components/TeamList/TeamList';
import { Faq } from '../faq/components/Faq/Faq';
import { ContactUs } from '@ui/common/components/ContactUs/ContactUs';

export const cmsWebComponentsMap = {
  [CmsComponent.ArticleHighlightedCard]: ArticleHighlightedCard,
  [CmsComponent.ArticleList]: ArticleList,
  [CmsComponent.RichTextPreview]: RichTextPreview,
  [CmsComponent.NewsletterSubscribe]: NewsletterSubscribe,
  [CmsComponent.LeagueTable]: LeagueTable,
  [CmsComponent.FixtureList]: FixtureList,
  [CmsComponent.ClubList]: ClubList,
  [CmsComponent.TeamList]: TeamList,
  [CmsComponent.SocialNetworks]: SocialNetworks,
  [CmsComponent.SponsorCard]: SponsorCard,
  [CmsComponent.SponsorsGrid]: SponsorsGrid,
  [CmsComponent.Ad]: Ad,
  [CmsComponent.FeaturedTags]: FeaturedTags,
  [CmsComponent.Link]: Link,
  [CmsComponent.ContactsList]: ContactsList,
  [CmsComponent.Faq]: Faq,
  [CmsComponent.ContactUs]: ContactUs,
};
